import { loadLanguageAsync } from '@/locales'
import Vue from 'vue'
import { LANG } from '@/store/mutation-types'

const i18n = {
  state: {
    lang: 'zh-CN',
    antLocale: {}
  },
  mutations: {
    SET_LANG: (state, lang) => {
      state.lang = lang
    },
    SET_LOCALE: (state,antLocale) => {
      state.antLocale = antLocale
    }
  },
  actions: {
    // 设置界面语言
    SetLang ({ commit }, lang) {
      return new Promise(resolve => {
        commit('SET_LANG', lang)
        Vue.ls.set(LANG, lang)
        loadLanguageAsync(lang)
        resolve()
      })
    },
    SetLocale({ commit }, antLocale){
      return new Promise(resolve => {
        commit('SET_LOCALE', antLocale)
        console.log('locale',antLocale)
        resolve()
      })
    }
  }
}

export default i18n
